enum PayeeState {
    Active = "ACTIVE",
    Deleted = "DELETED"
}
export default PayeeState